export const calcGradualPercentProgress = (progress, duration) => {
  if (!duration) {
    return 0;
  }

  const percentProgress = Math.floor((progress / duration) * 100);
  return Math.round(percentProgress / 10) * 10;
};

export const getTrackLanguage = (track = {}) => {
  return (track.lang || track.language || '').toLowerCase();
};
